import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listDetail } from '@/api/deposit.js';
import dayjs from 'dayjs';
import { listOptionType, listCashPledgeStatus, listPayType } from '@/api/dict.js';
import AddDepositComponent from './add.vue';
import ReduceDepositComponent from './reduce.vue';
export default {
  components: {
    AddDepositComponent: AddDepositComponent,
    ReduceDepositComponent: ReduceDepositComponent
  },
  data: function data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      form: {
        page: 1,
        pageSize: 10,
        total: 0,
        manuId: null
      },
      dataLoading: false,
      dataList: [],
      statusList: listCashPledgeStatus(),
      payTypeList: listPayType(),
      optionTypeList: listOptionType()
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    init: function init(manuRow) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.manuRow = manuRow;
                that.dialogVisible = true;
                that.dialogTitle = '押金申请明细';
                that.form.page = 1;
                that.form.manuId = manuRow.ID;
                that.loadData();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.dialogVisible = false;
      that.$emit('reload');
    },
    indexFormatter: function indexFormatter(index) {
      var that = this;
      return (that.form.page - 1) * that.form.pageSize + index + 1;
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                that.dataLoading = true;
                that.dataList = [];
                _context2.next = 5;
                return listDetail(that.form).then(function (res) {
                  res.list.map(function (row) {
                    row.CreatedAt = dayjs(row.CreatedAt).format('YYYY-MM-DD HH:mm:ss');
                    row.czAmount = row.productPrice + row.toolPrice;
                    row.checkDate = row.checkDate ? dayjs(row.checkDate).format('YYYY-MM-DD HH:mm:ss') : null;
                  });
                  that.dataList = res.list;
                  that.form.total = res.total;
                }).catch(function (e) {});

              case 5:
                that.dataLoading = false;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.form.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.form.page = 1;
      that.form.pageSize = pageSize;
      that.loadData();
    },
    optionType: function optionType(row) {
      var that = this;
      var findRow = that.optionTypeList.find(function (item) {
        return item.ID === row.optionType;
      });

      if (findRow) {
        return findRow.name;
      } else {
        return row.optionType;
      }
    },
    statusFormatter: function statusFormatter(row) {
      var findRow = this.statusList.find(function (item) {
        return item.ID === row.status;
      });

      if (findRow) {
        return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
      } else {
        return row.status;
      }
    },
    payTypeFormatter: function payTypeFormatter(row) {
      var that = this;
      var findRow = that.payTypeList.find(function (item) {
        return item.ID === row.payType;
      });

      if (findRow) {
        return findRow.name;
      } else {
        return row.payType;
      }
    },
    reEdit: function reEdit(row) {
      var that = this;
      var appRow = JSON.parse(JSON.stringify(row));
      appRow.pictureLicense = appRow.pictureLicense ? JSON.parse(appRow.pictureLicense) : [];

      if (appRow.optionType === 1) {
        that.$refs.AddDepositComponentRef.init(appRow, 'EDIT');
      } else if (appRow.optionType === 2) {
        appRow.dealerProductPrice = 0;
        appRow.dealerToolPrice = 0;
        that.$refs.ReduceDepositComponentRef.init(appRow, 'EDIT');
      }
    },
    viewDetail: function viewDetail(row) {
      var that = this;
      var appRow = JSON.parse(JSON.stringify(row));
      appRow.pictureLicense = appRow.pictureLicense ? JSON.parse(appRow.pictureLicense) : [];

      if (appRow.optionType === 1) {
        that.$refs.AddDepositComponentRef.init(appRow, 'VIEW');
      } else if (appRow.optionType === 2) {
        appRow.dealerProductPrice = 0;
        appRow.dealerToolPrice = 0;
        that.$refs.ReduceDepositComponentRef.init(appRow, 'VIEW');
      }
    }
  }
};